export default {
    apiKey: "AIzaSyCR2Adn51REJod1jSYdk3L49kGwFqdChW0",
    authDomain: "hiburim.firebaseapp.com",
    projectId: "hiburim",
    storageBucket: "hiburim.appspot.com",
    messagingSenderId: "1086120658507",
    appId: "1:1086120658507:web:b44a1c3b1c10e707c4efce",
    measurementId: "G-KHG7DWH9C8"
};
